import { render, staticRenderFns } from "./UserPayment.vue?vue&type=template&id=265977c4&"
import script from "./UserPayment.vue?vue&type=script&lang=js&"
export * from "./UserPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports